import {useHalState} from '@synako/haligator';
import {useTranslation} from 'react-i18next';
import {formatMaintenanceMessage} from '../utils/date-tools';
import {Resource} from '@synako/halitrek';
import {RootDesc as FFConnectRoot} from 'api-types/ffconnect-hal';

/**
 * Hook pour récupérer et formater le message de maintenance
 * @param api - L'objet resource de l'API racine (useApi())
 * @returns Le message de maintenance formaté (ou une chaîne vide si pas de maintenance)
 */
export const useMaintenanceMessage = (api: Resource<FFConnectRoot>) => {
  const {i18n} = useTranslation();
  const maintenanceNav = api.follow('get-annonce_de_maintenance');
  const maintenance = useHalState(maintenanceNav);

  // Le serveur renvoie l'annonce uniquement si elle doit être affichée
  const maintenanceData = maintenance.data;
  const messageMaintenance =
    maintenanceData?.message &&
    maintenanceData.commence_le &&
    maintenanceData.termine_le
      ? formatMaintenanceMessage(
          maintenanceData.message,
          maintenanceData.commence_le,
          maintenanceData.termine_le,
          i18n.language,
        )
      : '';

  return messageMaintenance;
};
